import { render, staticRenderFns } from "./NotificationsPopup.vue?vue&type=template&id=6c7a4bef&scoped=true"
import script from "./NotificationsPopup.vue?vue&type=script&lang=ts"
export * from "./NotificationsPopup.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsPopup.vue?vue&type=style&index=0&id=6c7a4bef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7a4bef",
  null
  
)

export default component.exports